import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const TarifsPage = lazy(() => import('../pages/tarifs/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const PressePage = lazy(() => import('../pages/presse/page'));
const MentionsLegalesPage = lazy(() => import('../pages/mentions-legales/page'));
const CGVPage = lazy(() => import('../pages/cgv/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/tarifs', element: <TarifsPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/gallery', element: <GalleryPage /> },
  { path: '/presse', element: <PressePage /> },
  { path: '/mentions-legales', element: <MentionsLegalesPage /> },
  { path: '/cgv', element: <CGVPage /> },
  { path: '*', element: <NotFoundPage /> },
];

export default routes;